import React from 'react';

import IconTheWeekend from '@components/Images/Rebranding/IconTheWeekend';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { Article } from '@interfaces/homepage';

import ArticlesGrid from './ArticlesGrid';

interface ExclusiveCoverageProps {
  exclusiveArticles: Article[];
  bigReadArticles: Article[];
}

const ExclusiveCoverage = ({ exclusiveArticles, bigReadArticles }: ExclusiveCoverageProps) => {
  const hydrated = useServerSideRendering();
  return (
    <div className="border-0 border-b border-t border-solid border-primary-magenta pb-64">
      <h4 className="text-center font-suisse-works text-headline-sm">Explore Our Coverage</h4>
      <section className="flex w-full justify-center pb-48 md:justify-start">
        <div className="flex flex-col justify-center">
          <h5 className="my-0 mb-32 max-w-[500px] px-24 font-suisse-works text-headline-xs sm:px-0 md:max-w-full ">
            Popular Articles
          </h5>
          {hydrated && <ArticlesGrid articles={exclusiveArticles} />}
        </div>
      </section>
      <section className="flex w-full justify-center border-0 border-t border-solid border-grayscale-beige md:justify-start">
        <div className="flex max-w-[500px] flex-col justify-center md:w-full md:max-w-full">
          <div className="flex items-center justify-between pt-48">
            <h4 className="my-0 font-suisse-works text-headline-xs">The Big Read</h4>
            <IconTheWeekend className="h-[20px] w-[132px]" />
          </div>
          <p className="my-0 mb-32 mt-8 max-w-[768px] font-suisse-intl text-description-lg font-light">
            Your weekly long read that offers unparalleled insights into previously unexplored
            aspects of the finance world. Explore emerging venture capital hotspots, profiles of the
            industry’s most elusive power players and bird’s eye views of trends to keep an eye on.
          </p>
          <div className="flex flex-col items-center justify-center">
            {hydrated && (
              <ArticlesGrid articles={bigReadArticles} imageTagClass="h-[341px] sm:h-[247px]" />
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ExclusiveCoverage;
